// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".validation-container{position:relative;line-height:20px;color:#e64848}.validation-message{line-height:20px;font-size:1.2em}", ""]);
// Exports
module.exports = exports;
